import * as R from 'ramda';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { createSelector } from 'reselect';
import FormBuilder from 'components/forms/FormBuilder/FormBuilder';
import getUserData from '../../../state/selectors/getUserData';


const getInitialValues = createSelector(
  getUserData,
  R.applySpec({
    company: R.path(['customer', 'name']),
    name: R.prop('name'),
    email: R.prop('email'),
  }),
);

const BusinessInterestForm = compose(
  connect(R.applySpec({
    initialValues: getInitialValues,
  })),
  withProps(({ initialValues }) => ({
    hideOnSubmit: true,
    submitLabel: 'Request trial',
    successMessage: 'Thanks for registering your interest!',
    fields: [
      // If we have a user already, we can hide all the fields
      {
        type: 'text',
        name: 'company',
        label: 'Company',
        required: true,
        hidden: Boolean(initialValues.company),
      },
      {
        type: 'text',
        name: 'name',
        label: 'Name',
        required: true,
        hidden: Boolean(initialValues.name),
      },
      {
        type: 'email',
        name: 'email',
        label: 'Email',
        required: true,
        hidden: Boolean(initialValues.email),
      },
    ],
  })),
) (FormBuilder);

export default BusinessInterestForm;
